// src/pages/branding/examples/InterfaceExample.tsx
import React from 'react'
import { useUserContext } from 'common/context/UserContext.tsx'
import styles from './interfaceExample.module.css'

export const InterfaceExample: React.FC = () => {
  const { logoDataURI } = useUserContext()

  return (
    <div className={styles.wrapper}>
      {/* TOP BAR */}
      <div className={styles.topBar}>
        <div className={styles.topLeft}>
          {logoDataURI ? (
            <img src={logoDataURI} alt="Logo" className={styles.logoImg} />
          ) : (
            <div className={styles.logoPlaceholder} />
          )}
        </div>

        <div className={styles.breadcrumbs}>
          <span className={styles.breadcrumb} />
          <span className={styles.breadcrumbDot} />
          <span className={styles.breadcrumbActive} />
        </div>

        <div className={styles.topRight}>
          <div className={styles.userAvatar} />
        </div>
      </div>

      {/* BODY */}
      <div className={styles.body}>
        {/* SIDEBAR */}
        <div className={styles.sidebar}>
          <div className={`${styles.sidebarItem} ${styles.sidebarItemActive}`} />
          <div className={styles.sidebarItem} />
          <div className={styles.sidebarItem} />
          <div className={styles.sidebarItem} />
          <div className={styles.sidebarItem} />
        </div>

        {/* CONTENT */}
        <div className={styles.content}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardTitle} />
              <div className={styles.cardHeaderRight}>
                {/*<div className={styles.searchInput} />*/}
                {/*<div className={styles.filterSelect} />*/}
                <div className={styles.newButton} />
              </div>
            </div>
            <div className={styles.tableBody}/>
          </div>
        </div>
      </div>
    </div>
  )
}
